'use client'
import Page from '#/app/(blank)/maintenance/page';

export const metadata = {
  title: `En Mantenimiento | Tienda Claro ${process.env.NEXT_PUBLIC_COUNTRY}`,
}

export default Page;
